import { Card, CardBody, CardHeader, Divider, Button, Chip } from "@nextui-org/react";
import { EyeIcon } from "@heroicons/react/24/outline";
import RootAdmin from "../../../../components/layouts/RootAdmin";
import ClientDataGrid from "../../../../components/elements/ClientDataGrid";
import { getFetcher } from "../../../../services/api";
import useSWR from "swr";
import useAuth from "../../../../hooks/useAuth";
import useCustomNavigate from "../../../../hooks/useCustomNavigate";
import { useMemo } from "react";
import { formattedDate } from "../../../../services/helpers";

export default function IndexPage() {
  const { user } = useAuth();
  const { getRegistrationDetailPath } = useCustomNavigate();

  const apiUrl = user?.id ? `/api/registrasi/find-all/search?delegasiUserId=${user.id}&returnAll=true&sortBy=tanggal_pengajuan&sortOrder=desc` : null;
  const { data, isLoading } = useSWR(apiUrl, getFetcher);

  const columns = useMemo(
    () => [
      { field: "index", headerName: "No" },
      { field: "nomor", headerName: "Nomor Registrasi" },
      { field: "name", headerName: "Perusahaan", valueGetter: (value, row) => row?.company?.name },
      { field: "tanggal_pengajuan", headerName: "Tanggal Masuk Data", valueGetter: (value, row) => formattedDate(value) },
      {
        field: "lama_proses",
        headerName: "Lama Proses",
        renderCell: (params) => {
          const lamaProses = params.row.lama_proses || 0;
          return lamaProses < 2 ? (
            <Chip color="success" variant="flat" size="sm">
              {lamaProses} Hari
            </Chip>
          ) : (
            <Chip color="danger" variant="flat" size="sm">
              {lamaProses} Hari
            </Chip>
          );
        },
      },
      {
        field: "status",
        headerName: "Status",
        renderCell: (params) => (
          <Chip size="sm" color="primary" variant="faded" className="capitalize">
            {params.value}
          </Chip>
        ),
      },
      {
        field: "id",
        headerName: "Aksi",
        renderCell: (params) => (
          <div className="flex gap-2">
            <Button size="sm" color="primary" isIconOnly onClick={() => getRegistrationDetailPath(params.value)}>
              <EyeIcon className="size-4" />
            </Button>
          </div>
        ),
      },
    ],
    [getRegistrationDetailPath]
  );

  return (
    <RootAdmin>
      <Card className="w-full mt-3" radius="sm">
        <CardHeader>
          <p className="text-md">Tugas Saya - Registrasi B3</p>
        </CardHeader>
        <Divider />
        <CardBody className="w-full h-[550px] p-5">
          <ClientDataGrid columns={columns} rows={data?.registrasi} isLoading={isLoading} />
        </CardBody>
      </Card>
    </RootAdmin>
  );
}
